module.exports = __webpack_public_path__ + "static/media/inmoLogo2.000a43bf.png";